<template>
  <v-runtime-template
    :template="show.templateSummary || templateFull"
  ></v-runtime-template>
</template>
<script>
import VRuntimeTemplate from 'v-runtime-template';
import ImageDisplay from '@/components/ImageDisplay.vue';
export default {
  components: { ImageDisplay, VRuntimeTemplate },
  props: {
    show: { type: Object, default: null }
  },
  data: function() {
    return {
      templateFull: `<div class="show-tile"><router-link :to="{ name: 'show', params: { showId: show.id } }">
      
        <div class="show-genre">{{show.genre}}</div><ImageDisplay :image="show.image" :height="200" :width="250" />
      <div class="content">
        <h3 class="show-name">{{ show.name }}</h3>
         <div class="show-dates">
          {{ show.startDate | formatDate }}
          <template v-if="show.endDate && show.endDate != show.startDate"
            >- {{ show.endDate | formatDate }}</template
          >
          <div class="show-space">{{show.space}}<template v-if="show.space && show.venue">, </template>{{show.venue}}</div>
        </div>
      </div>
    </router-link></div>`
    };
  }
};
</script>
